import { createAction, props } from '@ngrx/store';

import { DataObject } from '../models/core.models';

export const toggleObjectSelected = createAction(
  '[Selected] Toggle Object Selected',
  props<{ object: DataObject }>(),
);

export const clearSelectedObjects = createAction(
  '[Selected] Clear Selected Objects',
);
export const selectObject = createAction(
  '[Selected] Select Object',
  props<{ object: DataObject }>(),
);

export const selectObjects = createAction(
  '[Selected] Select Objects',
  props<{ objects: DataObject[] }>(),
);
export const deselectObject = createAction(
  '[Selected] Deselect Object',
  props<{ object: DataObject }>(),
);
